/** How long the API takes to start from zero replicas, as measured on dev. */
const EXPECTED_WARMUP_MS = 84_000;
/** Where the estimate stops: a stopped server can't report progress, so only its answer means ready. */
const MAX_ESTIMATED_PERCENT = 95;

/** An estimate, in whole percent, of how far a cold start that began at `startedAt` has got by `now`. */
export const estimateWarmupProgress = (startedAt: number, now: number): number => {
  const percent = Math.round(((now - startedAt) / EXPECTED_WARMUP_MS) * 100);
  return Math.min(MAX_ESTIMATED_PERCENT, Math.max(0, percent));
};
